export enum CookieCategory {
  NECCESSARY = 'necessary',
  PERFORMANCE = 'performance',
  FUNCTIONAL = 'functional',
  TARGETING = 'targeting',
  SOCIAL_MEDIA = 'social_media'
}
